import EasyDanmaku from './easyDanmaku.js';
export default EasyDanmaku